import React from "react";

import { Link } from "react-router-dom";

const columns = (updateRole = false) => {
  let returnArray = [
    {
      text: "Name",
      dataField: "name",
    },
    {
      text: "Completes Work Package",
      dataField: "completes",
	  formatter: (cell, row) => cell ? "Yes" : "No",
    },
  ];

  if (updateRole) {
    returnArray.push({
      text: "Edit",
      dataField: "edit",
      csvExport: false,
      formatter: (cell, row) => <Link to={`/drawing_office/work_package_statuses/${row.id}/edit`}>Edit</Link>,
    });
  }

  return returnArray;
};

export default columns;
